"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundamentalUtils = void 0;
const lucy_1 = require("../../@types/analysis/historical-prices/lucy");
const moment = require("moment/moment");
class FundamentalUtils {
    static getLucyIndication(periods) {
        const orderedDates = this.getPeriodOrderedDates(periods);
        const [oldestPeriod, penultimatePeriod, secondaryPeriod, mostRecentPeriod] = [
            periods[orderedDates[0]],
            periods[orderedDates[1]],
            periods[orderedDates[2]],
            periods[orderedDates[3]],
        ];
        const isGrowing = this.isGrowingPeriods(mostRecentPeriod, secondaryPeriod, penultimatePeriod, oldestPeriod);
        const isDrowning = this.isDrowningPeriods(mostRecentPeriod, secondaryPeriod, penultimatePeriod, oldestPeriod);
        const periodValues = [
            oldestPeriod,
            penultimatePeriod,
            secondaryPeriod,
            mostRecentPeriod,
        ];
        const isAllPeriodsNegative = this.isAllPeriodsNegative(periodValues);
        const qntNegativePeriods = this.getTotalNegativePeriods(periodValues);
        if (isAllPeriodsNegative && !isGrowing) {
            return lucy_1.eLucyFundamentalIndication.STRONG_SELL;
        }
        else if (isGrowing) {
            return lucy_1.eLucyFundamentalIndication.STRONG_BUY;
        }
        else if (isDrowning) {
            return lucy_1.eLucyFundamentalIndication.STRONG_SELL;
        }
        else if (mostRecentPeriod < 0 || qntNegativePeriods >= 3) {
            return lucy_1.eLucyFundamentalIndication.SELL;
        }
        else if (qntNegativePeriods === 0) {
            return lucy_1.eLucyFundamentalIndication.BUY;
        }
        return lucy_1.eLucyFundamentalIndication.NEUTRAL;
    }
    static isGrowingPeriods(mostRecent, secondary, penultimate, oldest) {
        return (mostRecent > secondary && secondary > penultimate && penultimate > oldest);
    }
    static isDrowningPeriods(mostRecent, secondary, penultimate, oldest) {
        return (oldest > penultimate && penultimate > secondary && secondary > mostRecent);
    }
    static getTotalNegativePeriods(periodsValues) {
        return periodsValues.filter((period) => period < 0).length;
    }
    static isAllPeriodsNegative(periodsValues) {
        return periodsValues.every((value) => value < 0);
    }
    static getPeriodOrderedDates(period) {
        return Object.keys(period).sort((a, b) => moment(a, 'DD.MM.YYYY').unix() - moment(b, 'DD.MM.YYYY').unix());
    }
}
exports.FundamentalUtils = FundamentalUtils;
//# sourceMappingURL=fundamental.utils.js.map